import {
  Columns,
  cellStyles1,
  cellStyles4,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/BasicTable';

export interface Diseases {
  condition: string;
  currentMembers: number;
  previousMembers: number;
  totalCost: number;
  memberIds: string[];
}
export interface CostTrendChartType {
  attachmentPoint: { value: string }[];
  rxPaidClaims?: { value: string }[];
  medicalPaidClaims?: { value: string }[];
  xAxisLabel: { label: string }[];
  dataSetProp: any[];
  paidClaims?: { label: string }[];
}

export const specificStopLossColumns: Columns[] = [
  {
    name: 'SPECIFIC STOP LOSS',
    align: 'left',
    cellStyles: {
      ...cellStyles1,
      height: '38px',
    },
    width: '100%',
  },
  {
    name: '',
    align: 'right',
    cellStyles: {
      ...cellStyles4,
      height: '38px',
    },
    width: '100%',
  },
];

export const aggregateStopLossColumns: Columns[] = [
  {
    name: 'AGGREGATE STOP LOSS',
    align: 'left',
    cellStyles: {
      ...cellStyles1,
      height: '38px',
    },
    width: '100%',
  },
  {
    name: '',
    align: 'right',
    cellStyles: {
      ...cellStyles4,
      height: '38px',
    },
    width: '100%',
  },
];

export const getAggregateReportColumns = (
  levelOfCoverage: string[],
): Columns[] => {
  const columns: Columns[] = [];

  columns.push({
    name: 'Months',
    align: 'left',
    cellStyles: {
      ...cellStyles1,
      height: '65px',
    },
    width: '110px',
  });
  levelOfCoverage.map((coverage) => {
    columns.push({
      name: coverage,
      align: 'center',
      cellStyles: {
        ...cellStyles4,
        height: '65px',
      },
      width: '160px',
    });
  });
  columns.push(
    {
      name: 'Monthly Aggregate Attachment Point',
      align: 'right',
      cellStyles: {
        ...cellStyles4,
        height: '65px',
      },
      width: '150px',
    },
    {
      name: 'Year To Date (YTD) Attachment Point',
      align: 'right',
      cellStyles: {
        ...cellStyles4,
        height: '65px',
      },
      width: '150px',
    },
    {
      name: 'Monthly Medical Paid Claims',
      align: 'right',
      cellStyles: {
        ...cellStyles4,
        height: '65px',
      },
      width: '150px',
    },
    {
      name: 'Monthly Rx Paid Claims',
      align: 'right',
      cellStyles: {
        ...cellStyles4,
        height: '65px',
      },
      width: '150px',
    },
    {
      name: 'Monthly Paid Claims',
      align: 'right',
      cellStyles: {
        ...cellStyles4,
        height: '65px',
      },
      width: '150px',
    },
    {
      name: 'Year To Date (YTD) Paid Claims',
      align: 'right',
      cellStyles: {
        ...cellStyles4,
        height: '65px',
      },
      width: '150px',
    },
    {
      name: 'Monthly Paid Claims Exceeding Specific Stop Loss',
      align: 'right',
      cellStyles: {
        ...cellStyles4,
        height: '65px',
      },
      width: '150px',
    },
    {
      name: 'YTD Paid Claims Exceeding Specific Stop Loss',
      align: 'right',
      cellStyles: {
        ...cellStyles4,
        height: '65px',
      },
      width: '150px',
    },
    {
      name: 'Monthly Paid Claims Outside Stop Loss',
      align: 'right',
      cellStyles: {
        ...cellStyles4,
        height: '65px',
      },
      width: '150px',
    },
    {
      name: 'YTD Paid Claims Outside Stop Loss',
      align: 'right',
      cellStyles: {
        ...cellStyles4,
        height: '65px',
      },
      width: '150px',
    },
    {
      name: 'Monthly Paid Claims Subj to Aggregate',
      align: 'right',
      cellStyles: {
        ...cellStyles4,
        height: '65px',
      },
      width: '150px',
    },
    {
      name: 'Year To Date (YTD) Paid Claims Subj to Aggregate',
      align: 'right',
      cellStyles: {
        ...cellStyles4,
        height: '65px',
      },
      width: '150px',
    },
    {
      name: 'Loss Ratio',
      align: 'right',
      cellStyles: {
        ...cellStyles4,
        height: '65px',
      },
      width: '150px',
    },
  );
  return columns;
};
export const coverageFieldMap: Record<string, string> = {
  Subscriber: 'Subsciber_only',
  'Subscriber and Spouse': 'Subsciber_+_spouse',
  'Parent and Children': 'Subsciber_+_children',
  Family: 'Subscriber_+_family',
  Composite: 'Composite',
  Other: 'Other',
};
